import Api from "~/service/Api";

class PhotoEditingImageRepository {
  importToTour(tourId, imagesIds) {
    return Api.post(`/photo-editing/images/import-to-tour/${tourId}`, {
      images: imagesIds,
    });
  }

  refund(photoEditingImageId) {
    return Api.post(`/photo-editing/images/${photoEditingImageId}/refund`);
  }
}

export default PhotoEditingImageRepository;
